import { render, staticRenderFns } from "./RestrictedIcon.vue?vue&type=template&id=ab8f0272&"
import script from "./RestrictedIcon.vue?vue&type=script&lang=js&"
export * from "./RestrictedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports